import { render } from "./AssignRoom.vue?vue&type=template&id=6899c86a&scoped=true"
import script from "./AssignRoom.vue?vue&type=script&lang=js"
export * from "./AssignRoom.vue?vue&type=script&lang=js"

import "./AssignRoom.vue?vue&type=style&index=0&id=6899c86a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6899c86a"

export default script